import classNames from 'classnames';
import React from 'react';
import {
  BizzaboIntegrationIcon,
  CalendlyIntegrationIcon,
  ChiliPiperIntegrationIcon,
  ClickupIntegrationIcon,
  FrontIntegrationIcon,
  GoogleDocsIntegrationIcon,
  GoogleDriveIntegrationIcon,
  GoogleFormsIntegrationIcon,
  GoogleSheetsIntegrationIcon,
  GoogleSlidesIntegrationIcon,
  HubspotIntegrationIcon,
  JotformIntegrationIcon,
  LoomIntegrationIcon,
  MixmaxIntegrationIcon,
  NotionIntegrationIcon,
  OutreachIntegrationIcon,
  PdfIntegrationIcon,
  PipedriveIntegrationIcon,
  PitchIntegrationIcon,
  SegmentIntegrationIcon,
  SlackIntegrationIcon,
  TypeformIntegrationIcon,
  VidyardIntegrationIcon,
  VimeoIntegrationIcon,
  WistiaIntegrationIcon,
  WufooIntegrationIcon,
  YoucanbookmeIntegrationIcon,
  YoutubeIntegrationIcon,
  ZapierIntegrationIcon,
} from 'src/monet/icons';

const BaseIntegrations = [
  LoomIntegrationIcon,
  NotionIntegrationIcon,
  GoogleSheetsIntegrationIcon,
  YoutubeIntegrationIcon,
  PitchIntegrationIcon,
  GoogleDocsIntegrationIcon,
  CalendlyIntegrationIcon,
  ClickupIntegrationIcon,
  GoogleDriveIntegrationIcon,
  GoogleFormsIntegrationIcon,
  HubspotIntegrationIcon,
  CalendlyIntegrationIcon,
  PdfIntegrationIcon,
  FrontIntegrationIcon,
  PipedriveIntegrationIcon,
  WufooIntegrationIcon,
  TypeformIntegrationIcon,
  VimeoIntegrationIcon,
  ChiliPiperIntegrationIcon,
  WistiaIntegrationIcon,
  VidyardIntegrationIcon,
  MixmaxIntegrationIcon,
  GoogleSlidesIntegrationIcon,
  JotformIntegrationIcon,
  OutreachIntegrationIcon,
  BizzaboIntegrationIcon,
  YoucanbookmeIntegrationIcon,
  SlackIntegrationIcon,
  SegmentIntegrationIcon,
  ZapierIntegrationIcon,
];

const IntegrationIcons = [...BaseIntegrations, ...BaseIntegrations];

const rightGradientClasses =
  'after:absolute after:inset-y-0 after:right-0 after:h-full after:w-6 after:bg-gradient-to-l after:from-bedrock-white after:to-transparent';

const leftGradientClasses =
  'before:absolute before:inset-y-0 before:left-0 before:h-full before:w-6 before:bg-gradient-to-r before:z-20 before:from-bedrock-white before:to-transparent';

export const WizardContentWelcome = () => (
  <div className='flex flex-col gap-4 text-bedrock-black'>
    <h1 className='text-bedrock-h1 font-brand-serif'>Conjure a Journey</h1>
    <p className='text-bedrock-p'>
      Quickly build a Journey by adding your links, documents, and files - we’ll do the rest
    </p>
    <div className={classNames('relative w-full overflow-hidden', leftGradientClasses, rightGradientClasses)}>
      <div
        className='w-[320px] flex-nowrap animate-[wizard-scroll_60s_linear_infinite]'
        style={{ animationDelay: '400ms' }}
      >
        <div className='flex gap-6 w-[1200px] slider-track'>
          {IntegrationIcons.map((IntegrationIcon, index) => (
            <IntegrationIcon key={`wizard-icon-${index}`} className='shrink-0 w-5 h-5' />
          ))}
        </div>
      </div>
    </div>
  </div>
);
